import { render, staticRenderFns } from "./closing-extend.vue?vue&type=template&id=0ac97ee7"
import script from "./closing-extend.vue?vue&type=script&lang=js"
export * from "./closing-extend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports